import userService from "../../services/user.service";
import { ActionTypes } from "../Constants/ActionTypes";

export const setSelectedGroupDetails = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.GROUP_LOADING,
    payload: {
      pageLoading: true,
      buttonLoading: false,
    },
  });
  userService
    .getGroupDetails(payload.id)
    .then((response) => {
      const { profilePhotoPath, groupCoaches, groupAthelets, groupTeamAdmins } =
        response.data.data;
      dispatch({
        type: ActionTypes.HANDLE_GROUP_LOGO_UPLOAD,
        payload: { filePath: profilePhotoPath, id: null },
      });
      dispatch({
        type: ActionTypes.SET_SELECTED_GROUP_DETAILS,
        payload: response.data.data,
      });
      if (groupCoaches.length > 0) {
        const newCoaches = groupCoaches.map(({ name: fullName, ...rest }) => ({
          fullName,
          ...rest,
        }));
        dispatch({
          type: ActionTypes.SET_SELECTED_COACHES_LIST,
          payload: newCoaches,
        });
      }
      if (groupAthelets.length > 0) {
        const newAthletes = groupAthelets.map(
          ({ name: fullName, ...rest }) => ({
            fullName,
            ...rest,
          })
        );
        dispatch({
          type: ActionTypes.SET_SELECTED_ATHLETES_LIST,
          payload: newAthletes,
        });
      }
      if (groupTeamAdmins.length > 0) {
        const newTeamAdmins = groupTeamAdmins.map(
          ({ name: fullName, ...rest }) => ({
            fullName,
            ...rest,
          })
        );
        dispatch({
          type: ActionTypes.SET_SELECTED_TEAM_ADMINS_LIST,
          payload: newTeamAdmins,
        });
      }

      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    });
};

export const activateOrDeactivateGroup = (dispatch, payload) => {
  userService
    .activateDeactivateGroup(payload.id, payload.status)
    .then(() => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: `Group ${
              payload.status === true ? "Activated" : "DeActivated"
            } Successfully.`,
            open: true,
          },
        },
      });
      dispatch({
        type: ActionTypes.ACTIVATE_OR_DEACTIVATE_GROUP,
        payload: payload.status,
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const deleteGroup = (dispatch, payload) => {
  userService
    .deleteGroupsApi(payload.id)
    .then(() => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: `Group Deleted Successfully.`,
            open: true,
            navigationLink: "/groups",
          },
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const createGroup = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.GROUP_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: true,
    },
  });
  userService
    .addGroups(
      payload.groupName,
      payload.coaches,
      payload.athletes,
      payload.teamAdmins,
      payload.schoolId,
      payload.uploadId
    )
    .then(() => {
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Group Created Successfully.",
            open: true,
            navigationLink: "/groups",
          },
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    });
};

export const getActiveCoachesList = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.GROUP_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: false,
      scrollLoading: true,
    },
  });
  userService
    .getAllCoachesDropdown(payload.schoolId, payload.page, payload.size)
    .then((response) => {
      var coachesDataTest = response.data.data.coaches;
      if (coachesDataTest != null) {
        dispatch({
          type: ActionTypes.GET_ACTIVE_COACHES_LIST,
          payload: {
            coachesList: coachesDataTest,
            page: payload.page,
            size: payload.size,
            total: response.data.data.total,
            totalPages: response.data.data.totalPages,
            status: payload.status,
          },
        });
        dispatch({
          type: ActionTypes.GROUP_LOADING,
          payload: {
            pageLoading: false,
            buttonLoading: false,
            scrollLoading: false,
          },
        });
      }
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          scrollLoading: false,
        },
      });
    });
};

export const getActiveAthletesList = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.GROUP_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: false,
      scrollLoading: true,
    },
  });
  userService
    .getAllAtheleteDropdown(payload.schoolId, payload.page, payload.size)
    .then((response) => {
      var atheleteDataTest = response.data.data.athletes;
      if (atheleteDataTest != null) {
        dispatch({
          type: ActionTypes.GET_ACTIVE_ATHELETS_LIST,
          payload: {
            athletesList: atheleteDataTest,
            page: payload.page,
            size: payload.size,
            total: response.data.data.total,
            totalPages: response.data.data.totalPages,
            status: payload.status,
          },
        });
        dispatch({
          type: ActionTypes.GROUP_LOADING,
          payload: {
            pageLoading: false,
            buttonLoading: false,
            scrollLoading: false,
          },
        });
      }
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          scrollLoading: false,
        },
      });
    });
};

export const getActiveTeamAdminsList = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.GROUP_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: false,
      scrollLoading: true,
    },
  });
  userService
    .getAllActiveTeamAdmins(payload.schoolId, payload.page, payload.size)
    .then((response) => {
      var teamAdminResponses = response.data.data.teamAdminResponses;
      if (teamAdminResponses != null) {
        dispatch({
          type: ActionTypes.GET_ACTIVE_TEAM_ADMINS_LIST,
          payload: {
            teamAdminsList: teamAdminResponses,
            page: payload.page,
            size: payload.size,
            total: response.data.data.total,
            totalPages: response.data.data.totalPages,
            status: payload.status,
          },
        });
        dispatch({
          type: ActionTypes.GROUP_LOADING,
          payload: {
            pageLoading: false,
            buttonLoading: false,
            scrollLoading: false,
          },
        });
      }
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          scrollLoading: false,
        },
      });
    });
};

export const setSelectedCoachesList = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SELECTED_COACHES_LIST,
    payload: payload.selectedList,
  });
};

export const setSelectedAthletesList = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SELECTED_ATHLETES_LIST,
    payload: payload.selectedList,
  });
};

export const setSelectedTeamAdminsList = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SELECTED_TEAM_ADMINS_LIST,
    payload: payload.selectedList,
  });
};

export const setSelectedGroupsList = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_SELECTED_GROUPS_LIST,
    payload: payload.selectedList,
  });
};

export const handleGroupLogoUpload = (dispatch, payload) => {
  const data = new FormData();
  data.append("file", payload.file);
  data.append("userId", payload.currentUserId);
  dispatch({
    type: ActionTypes.GROUP_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: false,
      scrollLoading: false,
      profileImageLoading: true,
    },
  });
  userService
    .postLogoForAll(data)
    .then((res) => {
      const { filePath, id } = res.data.data;
      dispatch({
        type: ActionTypes.HANDLE_GROUP_LOGO_UPLOAD,
        payload: { filePath, id },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          scrollLoading: false,
          profileImageLoading: false,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          scrollLoading: false,
          profileImageLoading: false,
        },
      });
    });
};

export const resetGroupData = (dispatch) => {
  dispatch({
    type: ActionTypes.RESET_GROUP_DATA,
  });
};

export const editGroupDetails = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.GROUP_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: true,
    },
  });
  userService
    .editGroups(
      payload.groupName,
      payload.coaches,
      payload.athletes,
      payload.teamAdmins,
      payload.schoolId,
      payload.groupLogoId,
      payload.groupId
    )
    .then(() => {
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Group Details Updated Successfully.",
            open: true,
            navigationLink: `/groupdetails/${payload.groupId}`,
          },
        },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
        },
      });
    });
};

export const setGroupSearchQuery = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_GROUP_SEARCH_QUERY,
    payload: payload,
  });
};

export const setGroupSearchedRecord = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_GROUP_SEARCHED_RECORD,
    payload: payload,
  });
};

export const searchActiveCoaches = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.GROUP_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: false,
      scrollLoading: true,
    },
  });
  userService
    .searchActiveCoaches(
      payload.searchQuery,
      payload.schoolId,
      payload.page,
      payload.size
    )
    .then((res) => {
      const { coaches, total, totalPages } = res.data.data;
      dispatch({
        type: ActionTypes.GET_ACTIVE_COACHES_LIST,
        payload: {
          coachesList: coaches,
          page: payload.page,
          size: payload.size,
          total: total,
          totalPages: totalPages,
          status: payload.status,
        },
      });
      dispatch({
        type: ActionTypes.SET_GROUP_SEARCHED_RECORD,
        payload: { pageStateName: "coachesPageState", status: true },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          scrollLoading: false,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          scrollLoading: false,
        },
      });
    });
};

export const searchActiveAthletes = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.GROUP_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: false,
      scrollLoading: true,
    },
  });
  userService
    .searchActiveAthletes(
      payload.searchQuery,
      payload.schoolId,
      payload.page,
      payload.size
    )
    .then((res) => {
      const { athletes, total, totalPages } = res.data.data;
      dispatch({
        type: ActionTypes.GET_ACTIVE_ATHELETS_LIST,
        payload: {
          athletesList: athletes,
          page: payload.page,
          size: payload.size,
          total: total,
          totalPages: totalPages,
          status: payload.status,
        },
      });
      dispatch({
        type: ActionTypes.SET_GROUP_SEARCHED_RECORD,
        payload: { pageStateName: "pageState", status: true },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          scrollLoading: false,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          scrollLoading: false,
        },
      });
    });
};

export const searchActiveTeamAdmins = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.GROUP_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: false,
      scrollLoading: true,
    },
  });
  userService
    .searchActiveTeamAdmins(
      payload.searchQuery,
      payload.schoolId,
      payload.page,
      payload.size
    )
    .then((res) => {
      const { teamAdminResponses, total, totalPages } = res.data.data;
      dispatch({
        type: ActionTypes.GET_ACTIVE_TEAM_ADMINS_LIST,
        payload: {
          teamAdminsList: teamAdminResponses,
          page: payload.page,
          size: payload.size,
          total: total,
          totalPages: totalPages,
          status: payload.status,
        },
      });
      dispatch({
        type: ActionTypes.SET_GROUP_SEARCHED_RECORD,
        payload: { pageStateName: "teamAdminPageState", status: true },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          scrollLoading: false,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          scrollLoading: false,
        },
      });
    });
};

export const getAllGroupList = (dispatch, payload) => {
  userService
    .getGroupsByPage(payload.schoolId, payload.page, payload.size)
    .then((res) => {
      const { total, totalPages, groups } = res.data.data;
      dispatch({
        type: ActionTypes.GET_ALL_GROUP_LIST,
        payload: {
          groupList: groups,
          page: payload.page,
          size: payload.size,
          total: total,
          totalPages: totalPages,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const searchGroup = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.GROUP_LOADING,
    payload: {
      pageLoading: false,
      buttonLoading: false,
      scrollLoading: true,
    },
  });
  userService
    .searchGroups(
      payload.searchQuery,
      payload.schoolId,
      payload.page,
      payload.size
    )
    .then((res) => {
      const { groups, total, totalPages } = res.data.data;
      dispatch({
        type: ActionTypes.GET_ALL_GROUP_LIST,
        payload: {
          groupList: groups,
          page: payload.page,
          size: payload.size,
          total: total,
          totalPages: totalPages,
        },
      });
      dispatch({
        type: ActionTypes.SET_GROUP_SEARCHED_RECORD,
        payload: { pageStateName: "groupPageState", status: true },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          scrollLoading: false,
        },
      });
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
      dispatch({
        type: ActionTypes.GROUP_LOADING,
        payload: {
          pageLoading: false,
          buttonLoading: false,
          scrollLoading: false,
        },
      });
    });
};
